<div
  class="progress-bar__track"
  role="progressbar"
  [attr.aria-valuenow]="mode === 'determinate' ? progressValue : null"
  [attr.aria-valuemin]="mode === 'determinate' ? 0 : null"
  [attr.aria-valuemax]="mode === 'determinate' ? 100 : null"
>
  <div class="progress-bar__buffer"></div>
  <div
    class="progress-bar__primary progress-bar__fill"
    [style.transform]="
      mode === 'determinate' ? 'scaleX(' + progressValue / 100 + ')' : null
    "
  ></div>
  <div class="progress-bar__secondary progress-bar__fill"></div>
</div>
